import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { ui } = constants.colors;
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const gridStyles = (columns, maxWidth) => {
  return {
    maxWidth: maxWidth ? `${maxWidth}px` : "100%",
    display: "grid",
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    columnGap: "24px",
    rowGap: "24px",
    "&:last-child": {
      marginTop: "24px",
    },
    alignItems: "flex-start",
    [breakpoint.upTo("xs")]: {
      width: "auto",
      gridTemplateColumns: "1fr",
      rowGap: "12px",
      "&:last-child": {
        marginTop: "12px",
      },
    },
  };
};

const gridColumnStyles = {
  [breakpoint.upTo("xs")]: {
    gridColumn: "unset",
    minWidth: "288px",
    maxWidth: "unset",
    width: "100%",
  },
};

export const gridColumnx1Styles = [
  {
    gridColumn: "span 1",
  },
  gridColumnStyles,
];

export const gridColumnx2Styles = [
  {
    gridColumn: "span 2",
  },
  gridColumnStyles,
];

export const gridColumnx3Styles = [
  {
    gridColumn: "span 3",
  },
  gridColumnStyles,
];

export const gridColumnx4Styles = [
  {
    gridColumn: "span 4",
  },
  gridColumnStyles,
];

export const gridColumnx5Styles = [
  {
    gridColumn: "span 5",
  },
  gridColumnStyles,
];

export const gridColumnFlexStyles = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  [breakpoint.upTo("xs")]: {
    flexFlow: "column",
  },
};

export const gridColumnFlexEndStyles = [
  gridColumnFlexStyles,
  {
    alignItems: "flex-end",
  },
];

export const buttonStyles = {
  root: {
    marginTop: "24px",
    backgroundColor: ui.core[700],
    [breakpoint.upTo("xs")]: {
      width: "100%",
    },
  },
};

export const inlineDivStyles = {
  label: typographyStyles.heading6Obj,
};

export const comboboxStyles = {
  maxWidth: "65%",
  marginRight: "24px",
  [breakpoint.upTo("xs")]: {
    width: "100%",
    maxWidth: "100%",
    marginBottom: "12px",
    marginRight: "0",
  },
  ul: {
    width: "100%",
    zIndex: 1,
  },
};

export const zipInputStyles = {
  root: {
    maxWidth: "35%",
    [breakpoint.upTo("xs")]: {
      maxWidth: "100%",
    },
  },
};

export const addDomainButtonStyles = {
  root: {
    color: ui.core[700],
    marginTop: "24px",
    [breakpoint.upTo("xs")]: {
      width: "100%",
      marginTop: "0",
    },
  },
};

export const statusInputStlyes = {
  marginRight: ".75rem",
};

export const subtitleStyles = {
  margin: "0",
  color: ui.neutral[600],
  fontSize: "1.5rem",
  marginBottom: "24px",
  [breakpoint.upTo("xs")]: {
    marginBottom: "24px",
    fontSize: "1.25rem",
  },
};

export const updateInformationButtonStyles = {
  root: {
    marginTop: "24px",
    backgroundColor: ui.core[700],
    [breakpoint.upTo("xs")]: {
      width: "100%",
    },
  },
};
